import { useState, useEffect } from "react";
import axios from "../../../config/axios";
import {
  Box,
  Select,
  TextField,
  Button,
  Grid,
  Paper,
  Chip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CommonDialog from "../../../components/CommonDialog";
import FormLabel from "../../../components/FormLabel";

const AddEditExpertiseModal = (props) => {
  const [expertise, setExpertise] = useState("");
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState("");

  // other functions
  const handleCloseModal = () =>
    props.setOpen((prevState) => ({
      ...prevState,
      addEditSkill: false,
    }));

  const addSkill = () => {
    if (newSkill) {
      setSkills([...skills, newSkill]);
      setNewSkill("");
    }
  };

  const removeSkill = (skill) => {
    const index = skills.indexOf(skill);
    const temp = [...skills];
    temp.splice(index, 1);
    setSkills([...temp]);
  };

  // API Services
  const handleEdit = () => {
    const name = props.expertiseOptions?.filter(
      (opt) => opt.id === expertise
    )[0]?.name;
    const body = {
      name,
      skills,
    };
    axios
      .put(`admin/expertises/${expertise}`, body)
      .then((res) => {
        if (res.status === 200) {
          props.setSkillOptions((prevState) => ({
            ...prevState,
            [`${expertise}`]: res.data.data?.skills || [],
          }));
          handleCloseModal();
          props.setAlertVariant("success");
          props.setDisplayAlert(true);
          props.setAlertMessage("Changes Saved Successfully");
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setSkills(props.skills);
    setExpertise(props.employeeData.expertise[0]);

    return () => {
      setSkills([]);
      setExpertise("");
    };
  }, []);

  return (
    <CommonDialog
      open={props.open.addEditSkill}
      title={"Manage Skill"}
      onSubmit={handleEdit}
      onClose={handleCloseModal}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box sx={{ padding: "10px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              {props.employeeData.expertise?.map((exp, index) => (
                <Box style={{ marginBottom: "5px" }} key={exp}>
                  <FormLabel title="Expertise" />
                  <Select
                    size={"small"}
                    style={{ width: "100%" }}
                    value={exp}
                    renderValue={() => {
                      const styles = {};
                      const value = exp
                        ? props.expertiseOptions.filter(
                            (opt) => opt.id === exp
                          )[0]?.name
                        : "Select";
                      if (value === "Select") {
                        styles.color = "#919fa5";
                      }
                      return <div style={styles}>{value}</div>;
                    }}
                    disabled={true}
                  ></Select>
                </Box>
              ))}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid
                container
                spacing={1}
                sx={{ display: "flex", alignItems: "end" }}
              >
                <Grid xs={9} sm={9} md={9} lg={9} xl={10} item>
                  <FormLabel title="Skill" />
                  <TextField
                    size="small"
                    fullWidth
                    sx={{ marginRight: "5px" }}
                    placeholder={"Skill Name"}
                    value={newSkill}
                    onChange={(e) => setNewSkill(e.target.value)}
                  />
                </Grid>
                <Grid xs={3} sm={3} md={3} lg={3} xl={2} item>
                  <Button
                    variant="contained"
                    sx={{ width: "100%", mb: "2px" }}
                    onClick={addSkill}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={2}>
                {skills.map((skill, index) => {
                  return (
                    <Grid item key={skill + index}>
                      <Chip
                        color="primary"
                        label={skill}
                        variant="outlined"
                        onDelete={() => removeSkill(skill)}
                        deleteIcon={<DeleteIcon />}
                      ></Chip>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </CommonDialog>
  );
};

export default AddEditExpertiseModal;
